import React from 'react'
import { Megaphone, BadgeCheck, ExternalLink } from 'lucide-react'
import { relativeTime } from '../utils/format'

export default function PressReleases({ items }) {
  if (!items?.length) return null

  return (
    <div className="onds-card p-5 md:p-6">
      <div className="flex items-center gap-2 mb-4">
        <Megaphone className="h-5 w-5" style={{ color: 'var(--onds-accent)' }} />
        <h2 className="text-lg font-bold">Latest Press Releases</h2>
        <span className="text-sm text-[var(--onds-text-dim)]">straight from the company newsroom</span>
      </div>

      <div className="flex flex-col gap-3 overflow-y-auto onds-scrollbar pr-1" style={{ maxHeight: 460 }}>
        {items.map((item, i) => {
          const Wrapper = item.url ? 'a' : 'div'
          const linkProps = item.url ? { href: item.url, target: '_blank', rel: 'noopener noreferrer' } : {}
          return (
            <Wrapper
              key={item.url || i}
              {...linkProps}
              className="group rounded-xl p-4 border transition hover:translate-x-0.5 block"
              style={{ backgroundColor: 'var(--onds-surface)', borderColor: 'var(--onds-border)' }}
            >
              <div className="flex items-center justify-between gap-2 mb-1.5">
                <span className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-[var(--onds-text-dim)] min-w-0">
                  {item.official && <BadgeCheck className="h-3.5 w-3.5 shrink-0" style={{ color: 'var(--onds-accent)' }} />}
                  <span className="truncate">{item.source}</span>
                </span>
                <div className="flex items-center gap-2 shrink-0">
                  <span className="text-[11px] text-[var(--onds-text-dim)]">{relativeTime(item.publishedAt)}</span>
                  {item.url && <ExternalLink className="h-3.5 w-3.5 text-[var(--onds-text-dim)] group-hover:text-[var(--onds-accent)] transition-colors" />}
                </div>
              </div>
              <h3 className="font-semibold leading-snug mb-1">{item.title}</h3>
              {item.summary && (
                <p className="text-sm text-[var(--onds-text-dim)] leading-relaxed line-clamp-3">{item.summary}</p>
              )}
            </Wrapper>
          )
        })}
      </div>
    </div>
  )
}
